// extracted by mini-css-extract-plugin
module.exports = {"get_code_check":"GetCode_get_code_check__8y5ZW"};